import React, {Component} from 'react'
import Slide from '@material-ui/core/Slide'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import BkFlowRoomCardRateStagePriceCollection from '../../multi-stage/BkFlowRoomCardRateStagePriceCollection'
import BkFlowRoomCardRateStagePriceButton from '../../multi-stage/BkFlowRoomCardRateStagePriceButton'

import yn from 'yn'
import _ from 'lodash'

if (process.env.REACT_APP_COMPONENT_ROOM_CARD_RATES_COMPONENT === 'drawer') {
  require('../../../../../styles/css/components/room/bk-flow-room-card-dynamic-rates-drawer.css')
}

class BkFlowRoomCardDynamicRatesDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillUnmount() {
    document.body.classList.remove('dynamic-drawer-open')
  }

  render() {
    const {
      activeCurrencyData,
      cards,
      currentRateCode,
      currentUpSells,
      featuredRatePlans,
      hotelLabels,
      ratePlanData,
      roomGroup,
      roomRateStageExpanded,
      roomRateStageEvent,
      toggleActiveRoom,
      totalNights,
      upSellsToggleEvent,
    } = this.props

    let renderRoomPriceSections = []
    const roomTypeName = _.get(cards, 'roomDescription.name')

    if (
      cards &&
      cards.viewExtensions &&
      cards.viewExtensions.roomRates &&
      yn(process.env.REACT_APP_COMPONENT_ENABLE_PARENT_CHILD_RATE_SORTING)
    ) {
      const roomRates = cards.viewExtensions.roomRates

      let parentRoomRates = []
      let childRoomRates = []

      // Construct arrays of parent and children roomRates based on viewExtension existing
      for (const rateKey in roomRates) {
        let hasParentRate = false

        const roomRate = roomRates[rateKey]

        if (
          roomRate &&
          roomRate.viewExtensions &&
          roomRate.viewExtensions.parentRatePlanCode
        ) {
          hasParentRate = true
        }

        if (hasParentRate) {
          childRoomRates.push(roomRate)
        } else {
          parentRoomRates.push(roomRate)
        }
      }

      // Display parent rates, and pass applicable child roomRate & ratePlan to parent component
      for (const rateKey in parentRoomRates) {
        const parentRoomRate = parentRoomRates[rateKey],
          parentRatePlan = ratePlanData.filter(function(rate) {
            return rate.ratePlanCode === parentRoomRate.ratePlanCode
          }),
          childRoomRate = childRoomRates.filter(function(rate) {
            return rate.viewExtensions.parentRatePlanCode === parentRoomRate.ratePlanCode && rate.roomTypeCode === parentRoomRate.roomTypeCode
          })

        let childRatePlan = null

        if (
          childRoomRate &&
          childRoomRate[0]
        ) {
          childRatePlan = ratePlanData.filter(function(rate) {
            return rate.ratePlanCode === childRoomRate[0].ratePlanCode
          })
        }

        if (
          childRoomRate &&
          childRoomRate[0] &&
          childRatePlan &&
          childRatePlan[0]
        ) {
          renderRoomPriceSections.push(
            <BkFlowRoomCardRateStagePriceCollection
              key={ parentRoomRate.ratePlanCode }
              activeCurrencyData={activeCurrencyData}
              currentRateCode={currentRateCode}
              currentUpSells={currentUpSells}
              totalNights={totalNights}
              roomGroup={roomGroup}
              roomRateData={parentRoomRate}
              ratePlanData={parentRatePlan[0]}
              toggleActiveRoom={toggleActiveRoom}
              childRoomRateData={childRoomRate && childRoomRate[0] && childRoomRate[0]}
              childRatePlanData={childRatePlan && childRatePlan[0] && childRatePlan[0]}
              upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
            />
          )
        } else {
          renderRoomPriceSections.push(
            <BkFlowRoomCardRateStagePriceButton
              key={ parentRoomRate.ratePlanCode }
              activeCurrencyData={activeCurrencyData}
              currentRateCode={currentRateCode}
              currentUpSells={currentUpSells}
              featuredRatePlans={featuredRatePlans}
              totalNights={totalNights}
              roomGroup={roomGroup}
              roomRateData={parentRoomRate}
              ratePlanData={parentRatePlan[0]}
              toggleActiveRoom={toggleActiveRoom}
              upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
            />
          )
        }
      }
    } else if (
      cards &&
      cards.viewExtensions &&
      cards.viewExtensions.roomRates
    ) {
      const roomRates = cards.viewExtensions.roomRates

      for (const rateKey in roomRates) {
        const roomRate = roomRates[rateKey],
          roomRatePlan = ratePlanData.filter(function(rate) {
            return rate.ratePlanCode === roomRate.ratePlanCode
          })

        renderRoomPriceSections.push(
          <BkFlowRoomCardRateStagePriceButton
            key={ roomRate.ratePlanCode }
            activeCurrencyData={activeCurrencyData}
            currentRateCode={currentRateCode}
            currentUpSells={currentUpSells}
            featuredRatePlans={featuredRatePlans}
            totalNights={totalNights}
            roomGroup={roomGroup}
            roomRateData={roomRate}
            ratePlanData={roomRatePlan[0]}
            toggleActiveRoom={toggleActiveRoom}
            upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
          />
        )
      }
    }

    return (
      <div className={`bk-flow-room__dynamic-rates-drawer${roomRateStageExpanded ? ' active' : ''}`}>
        <Slide
          direction="left"
          in={ roomRateStageExpanded }
          timeout={ 500 }
          mountOnEnter={ true }
          unmountOnExit={ true }
          onEntering={() => document.body.classList.add('dynamic-drawer-open')}
          onExit={() => document.body.classList.remove('dynamic-drawer-open')}
        >
          <ClickAwayListener onClickAway={() => roomRateStageEvent(false)}>
            {renderRoomPriceSections &&
            <div className="bk-flow-room__dynamic-rates-drawer-rates">
              <div className="rates-heading">
                <button
                  onClick={() => roomRateStageEvent(false)}
                  className="btn btn-text-only"
                >
                  <i className="material-icons">keyboard_arrow_left</i>
                  {hotelLabels && hotelLabels.backToRooms ? hotelLabels.backToRooms : 'Back to Rooms'}
                </button>

                {roomTypeName &&
                  <h2>{roomTypeName}<span>&nbsp;-&nbsp;</span>{hotelLabels && hotelLabels.roomRates ? hotelLabels.roomRates : 'Room Rates'}</h2>
                }
              </div>
              <div className="rates-entries">
                { renderRoomPriceSections }
              </div>
            </div>
            }
          </ClickAwayListener>
        </Slide>
      </div>
    )
  }
}

export default BkFlowRoomCardDynamicRatesDrawer



// WEBPACK FOOTER //
// ./src/components/room/elements/default/dynamic/BkFlowRoomCardDynamicRatesDrawer.js